import React from 'react'
import cs from 'classnames'
import ButtonLink from '../ButtonLink'

type TemplateDownloaderProps = {
	text: string
	url: string
	className?: string
}

export default function TemplateDownloader({ text, url, className }: TemplateDownloaderProps) {
	const cx = cs('templateDownloader', className)
	return (
		<ButtonLink iconName='download' className={cx}>
			<a href={url} target='_blank' rel='noreferrer'>
				{text}
			</a>
		</ButtonLink>
	)
}
